import React from 'react';
import './CreditsDisplay.css';

/**
 * Displays user's credit balance as a clickable button
 * @param {Object} props
 * @param {number|null} props.credits - Current credit balance
 * @param {boolean} props.loading - Whether credits are being fetched
 * @param {Function} props.onClick - Handler for when button is clicked
 */
export default function CreditsDisplay({ credits, loading, onClick }) {
  if (loading) {
    return (
      <button className="credits-display credits-loading" disabled>
        <span className="credits-icon">💎</span>
        <span className="credits-spinner"></span>
      </button>
    );
  }

  return (
    <button
      className="credits-display"
      onClick={onClick}
      title={credits != null ? `${credits} gems` : undefined}
    >
      <span className="credits-icon">💎</span>
      <span className="credits-amount">{credits ?? '-'}</span>
    </button>
  );
}
